// Unified client picker (customer OR company) backed by the `search_clients` RPC.
// Used by CreateReservation and the /invoicing/create page.
//
// Props:
//   open        - bool   - whether the modal is shown
//   onClose     - fn     - called when the user dismisses
//   onSelect    - fn     - called with `{ client_type: "customer" | "company",
//                           id, name, detail }` when a row is clicked

import React, { useState } from "react";
import { Modal, TextField, Text, Badge } from "@shopify/polaris";
import supabase from "../../../supabase-client";
import { blockReasonLabel } from "../../../utility/clientBlocks";

function ClientSearch({ open, onClose, onSelect, title = "Buscar Cliente" }) {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleQuery = async (val) => {
    setQuery(val);
    if (val.trim().length < 2) {
      setResults([]);
      return;
    }
    setLoading(true);
    const { data } = await supabase.rpc("search_clients", {
      search_text: val.trim(),
    });
    setResults(data || []);
    setLoading(false);
  };

  const handlePick = (r) => {
    if (onSelect) onSelect(r);
    setQuery("");
    setResults([]);
  };

  const handleClose = () => {
    setQuery("");
    setResults([]);
    if (onClose) onClose();
  };

  return (
    <Modal open={open} onClose={handleClose} title={title}>
      <Modal.Section>
        <TextField
          label="Buscar empresa o persona"
          value={query}
          onChange={handleQuery}
          placeholder="Nombre, RFC, teléfono..."
          loading={loading}
          autoComplete="off"
          focused
        />
        <div style={{ marginTop: "0.5rem", maxHeight: 300, overflow: "auto" }}>
          {results.map((r) => (
            <div
              key={`${r.client_type}_${r.id}`}
              style={{
                padding: "8px 12px",
                cursor: "pointer",
                borderBottom: "1px solid #eee",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              onClick={() => handlePick(r)}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#f5f5f5";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
              }}
            >
              <div>
                <Text variant="bodySm" fontWeight="semibold">
                  {r.name}
                </Text>
                <Text variant="bodySm" tone="subdued">
                  {r.detail}
                </Text>
              </div>
              <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                {r.blocked && (
                  <Badge size="small" tone="critical">
                    {`Bloqueado · ${blockReasonLabel(r.block_reason)}`}
                  </Badge>
                )}
                <Badge
                  size="small"
                  tone={r.client_type === "company" ? "info" : "default"}
                >
                  {r.client_type === "company" ? "Empresa" : "Persona"}
                </Badge>
              </div>
            </div>
          ))}
        </div>
      </Modal.Section>
    </Modal>
  );
}

export default ClientSearch;
